import { QueryAggregator } from "@/api/utils/QueryAggregator"
import { IImbpSmartMeterOfferedSlot } from "@/models/imbpSmartMeterOfferedSlots/imbpSmartMeterOfferedSlot.types"
import { AccountService } from "@/services/AccountService"
import { ImbpService } from "@/services/ImbpService"

export const getImbpPreviouslyOfferedSlots = (accountNumber: string) => {
  const queries = new QueryAggregator()

  const coreIdQuery = AccountService.getCoreIdByAccountNumber(accountNumber)
  queries.add(coreIdQuery)

  let imbpSmartMeterOfferedSlots: IImbpSmartMeterOfferedSlot[] | null = null

  if (coreIdQuery.data) {
    const imbpPreviouslyOfferedSlotsQuery =
      ImbpService.getPreviouslyOfferedSmartMeterSlots(coreIdQuery.data)

    imbpSmartMeterOfferedSlots = imbpPreviouslyOfferedSlotsQuery.data
    queries.add(imbpPreviouslyOfferedSlotsQuery)
  }

  return queries.setData(imbpSmartMeterOfferedSlots).getAggregate()
}
